import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { DataCapsule, WixStorageStrategy } from '@wix/data-capsule';
import { dataCapsuleNamespace } from '../consts';
export class BookingsDataCapsule {
  constructor(flowApi) {
    _defineProperty(this, "flowApi", void 0);
    _defineProperty(this, "dataCapsule", void 0);
    this.flowApi = flowApi;
    this.dataCapsule = new DataCapsule({
      strategy: new WixStorageStrategy({
        httpClient: this.flowApi.httpClient
      }),
      namespace: dataCapsuleNamespace
    });
  }
  static getInstance(flowApi) {
    if (!BookingsDataCapsule.instance) {
      BookingsDataCapsule.instance = new BookingsDataCapsule(flowApi);
    }
    return BookingsDataCapsule.instance;
  }
  async setItem(key, value, options) {
    return this.dataCapsule.setItem(key, value, options);
  }
  async getItem(key, options) {
    try {
      return await this.dataCapsule.getItem(key, options);
    } catch (e) {
      return undefined;
    }
  }
  async removeItem(key, options) {
    return this.dataCapsule.removeItem(key, options);
  }
  async getAllItems(options) {
    return this.dataCapsule.getAllItems(options);
  }
}
_defineProperty(BookingsDataCapsule, "instance", void 0);
//# sourceMappingURL=index.js.map